import axios from 'axios'

const

  URL = process.env.VUE_APP_API_URL + '/',

  get = quadrant => new Promise ((resolve, reject) => axios
    .get(URL + quadrant)
    .then(response => resolve(response.data))
    .catch(error => reject(error))
  ),

  getAll = quads => new Promise(( resolve, reject ) => {
    Promise.all(Object
     .keys  ( quads )
     .map   ( async key => quads[key] = await get( key ) ) )
     .then  ( quads => resolve ( quads ) )
     .catch ( error => reject  ( error ) )
  })

export default {
  get,
  getAll
}
